module.exports = __webpack_public_path__ + "static/media/favourite-inactive.897d22e8.svg";